import React, { useEffect, useState } from "react";
import Spinner from "../../Components/Spinner/Spinner";
import { useLocation } from "react-router-dom";
import { MdEditSquare } from "react-icons/md";
import {
  config,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
  updateValueInLocalStorage,
} from "../../utils/helper";
import { authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";

const ProfileDetails = ({ userData, Loading, error }) => {
  const localStorageUserData = JSON.parse(localStorage.getItem("userData"));
  const role = localStorageUserData?.role;
  const adminId = localStorageUserData?.adminId;
  const userId = userData?._id;
  const location = useLocation();
  const path = location.pathname;
  const pathName = path.split("/");
  const [showFullReason, setShowFullReason] = useState(false);
  const [showStatusPopup, setShowStatusPopup] = useState(false);
  const isAdminLike = role === "admin" || role === "superAdmin" || role === "coordinator";
  const canManage = role === "admin" || role === "superAdmin";

  const getProfileStatusType = (userData) => {
    if (!userData) return null;

    const completion = userData.profileCompletionPercentage;

    if (completion === 0) {
      return "SignUp";
    }

    const isActive =
      "isActive" in userData ? userData.isActive : userData.profileCompleted;

    if (completion > 0 && isActive === false) {
      return "register";
    }

    if (
      completion === 100 &&
      (!userData.hasOwnProperty("isActive") || userData.isActive)
    ) {
      return "active";
    }
    return null;
  };

  let statusType = getProfileStatusType(userData);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isselectedStatus, setIsSelectedStatus] = useState(false);
  const [errors, setErrors] = useState(false);
  const [statusError, setStatusError] = useState("");
  const [statusReason, setStatusReason] = useState("");
  console.log("current status:", statusType);

  const handleClose = () => {
    setIsSelectedStatus(false);
    setShowStatusPopup(false);
    setErrors(false);
  };

  const handleStatusChange = async () => {
    if (selectedStatus === "") {
      setErrors(true);
      return;
    }
    if (
      (selectedStatus === "notInterest" || selectedStatus === "noResponse") &&
      statusReason.trim().length < 15
    ) {
      setStatusError("Reason must be at least 15 characters.");
      return;
    }
    try {
      let isActiveStatus;
      if (
        (selectedStatus || statusType) === "active" ||
        (selectedStatus || statusType) === "register" ||
        (selectedStatus || statusType) === "signup"
      ) {
        isActiveStatus = true;
      } else {
        isActiveStatus = false;
      }
      const data = {
        adminId: adminId,
        userId: userId,
        status: selectedStatus,
        activeStatus: isActiveStatus,
        ...(isActiveStatus === false && { reason: statusReason }),
      };
      const res = await authorizedPost(
        configuration.apis.userChangeStatus,
        data,
        config,
      );
      const response = res?.data;
      if (response?.status) {
        successNotify(response?.message);
        setIsSelectedStatus(true);
        const searchData = localStorage.getItem("searchResults");
        const filteredData = localStorage.getItem("filteredData");

        const localData = searchData ? searchData : filteredData;
        const filter = searchData ? "searchResults" : "filteredData";

        if (localData) {
          if (selectedStatus === "notInterest") {
            updateData(
              userId,
              {
                isNotInterested: true,
                isNoResponse: false,
              },
              localData,
              filter,
            );
          }
          if (selectedStatus === "noResponse") {
            updateData(
              userId,
              {
                isNoResponse: true,
                isNotInterested: false,
              },
              localData,
              filter,
            );
          } else if (selectedStatus === "signup") {
            updateData(
              userId,
              {
                profileCompletionPercentage: 0,
                profileCompleted: false,
                isActive: false,
                isNoResponse: false,
                isNotInterested: false,
              },
              localData,
              filter,
            );
          } else if (selectedStatus === "register") {
            updateData(
              userId,
              {
                profileCompletionPercentage: 88,
                profileCompleted: true,
                isActive: false,
                isNoResponse: false,
                isNotInterested: false,
              },
              localData,
              filter,
            );
          } else if (selectedStatus === "active") {
            updateData(
              userId,
              {
                profileCompletionPercentage: 100,
                profileCompleted: true,
                isActive: true,
                isNoResponse: false,
                isNotInterested: false,
              },
              localData,
              filter,
            );
          }
        }
      } else {
        errorNotify(response?.message);
      }
    } catch (error) {
      console.log(error);
      errorNotify(error.error);
    } finally {
      setShowStatusPopup(false);
    }
  };

  const updateData = (id, updates, localData, filter) => {
    let data = JSON.parse(localData);

    data = data.map((local) =>
      local._id === id ? { ...local, ...updates } : local,
    );

    console.log(data);

    localStorage.setItem(filter, JSON.stringify(data));
  };
  const handleReasonChange = (e) => {
    const input = e.target.value;

    setStatusReason(input);
    setStatusError(
      input.trim().length < 15 ? "Reason must be at least 15 characters." : "",
    );
  };
  if (Loading) {
    return (
      <div className="flex h-screen items-center justify-center text-center text-lg">
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center text-center text-lg">
        {error}
      </div>
    );
  }

  if (!Loading && !userData) {
    return (
      <div className="flex h-screen items-center justify-center text-center text-lg">
        No data available
      </div>
    );
  }
  const basicInfo = userData?.profile?.basicInformation || {};
  const toggleReason = () => setShowFullReason(!showFullReason);

  const reason = userData?.userStatus?.reason;
  const isLongReason = reason && reason.length > 125;
  const displayedReason =
    isLongReason && !showFullReason ? reason.slice(0, 125) + "..." : reason;

  return (
    <div className="font-jost mx-auto p-2 md:p-6">
      <div>
        {/* Personal Information */}
        <div className="mb-2 bg-white px-4">
          <h3 className="font-jost mb-2 text-xl text-textYellow">
            Personal Information
          </h3>
          <div className="flex  flex-col md:flex-row md:flex-wrap">
            <p className="mb-2 w-full md:w-1/2">
              <span className="font-medium">Name:</span>{" "}
              {userData?.name || "NA"}
            </p>
            <p className="mb-2 w-full md:w-1/2">
              <span className="font-medium">Age:</span>{" "}
              {userData?.dob
                ? (() => {
                    const parts = new Date(userData.dob)
                      .toLocaleDateString("en-CA")
                      .split("-");
                    const birth = new Date(parts[0], parts[1] - 1, parts[2]);
                    const today = new Date();
                    let age = today.getFullYear() - birth.getFullYear();
                    const m = today.getMonth() - birth.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birth.getDate()))
                      age--;
                    return age;
                  })()
                : "NA"}{" "}
            </p>
            <p className="mb-2 w-full md:w-1/2">
              <span className="font-medium">Gender:</span>{" "}
              {userData?.gender || "NA"}
            </p>
            <p className="mb-2 w-full md:w-1/2">
              <span className="font-medium">Profile Completion:</span>{" "}
              {userData?.profileCompletionPercentage}%
            </p>

            <p className="mb-2 w-full md:w-1/2">
              <span className="font-medium">Marital Status:</span>{" "}
              {userData?.maritalStatus || "NA"}
            </p>

            <p className="mb-2 w-full md:w-1/2">
              <span className="font-medium">Profile Status:</span>{" "}
              {userData?.profileCompletionPercentage === 100 &&
              (!userData?.hasOwnProperty("isActive") || userData?.isActive)
                ? "Active"
                : "Inactive"}
            </p>
            <p className="mb-2 w-full md:w-1/2">
              <span className="font-medium">DOB:</span>{" "}
              {userData?.dob ? userData.dob.split("T")[0] : "NA"}
            </p>

            {isAdminLike && (
              <div className="mb-2 w-full md:w-1/2">
                <p>
                  <span className="font-medium">Profile Stage:</span>{" "}
                  {userData?.isNotInterested ? (
                    <>
                      <span className="inline-block rounded-full bg-gray-300 px-3 py-1 text-sm font-semibold text-gray-600">
                        {isselectedStatus ? selectedStatus : "Not Interested"}
                      </span>
                      {canManage && (
                        <MdEditSquare
                          onClick={() => setShowStatusPopup(true)}
                          className="text-grey-500 hover:text-grey-600 ml-2
                                  inline-block cursor-pointer"
                        />
                      )}
                      {(userData?.userStatus?.reason || statusReason) && (
                        <div className="mt-1">
                          <span className="font-medium">Reason:</span>{" "}
                          <span className="text-sm text-gray-600">
                            {isselectedStatus ? statusReason : displayedReason}
                          </span>
                          {isLongReason && (
                            <button
                              onClick={toggleReason}
                              className="ml-2 text-sm text-blue-600 hover:underline focus:outline-none"
                            >
                              {showFullReason ? "Show Less" : "Read More"}
                            </button>
                          )}
                        </div>
                      )}
                    </>
                  ) : userData?.isNoResponse ? (
                    <>
                      <span className="inline-block rounded-full bg-gray-300 px-3 py-1 text-sm font-semibold text-gray-600">
                        {isselectedStatus ? selectedStatus : "No Response"}
                      </span>
                      {canManage && (
                        <MdEditSquare
                          onClick={() => setShowStatusPopup(true)}
                          className="text-grey-600 hover:text-grey-600 ml-2
                                  inline-block cursor-pointer"
                        />
                      )}
                      {(userData?.userStatus?.reason || statusReason) && (
                        <div className="mt-1 ">
                          <span className="font-medium">Reason:</span>{" "}
                          <span className="text-sm text-gray-600">
                            {isselectedStatus ? statusReason : displayedReason}
                          </span>
                          {isLongReason && (
                            <button
                              onClick={toggleReason}
                              className="ml-2 text-sm text-blue-600 hover:underline focus:outline-none"
                            >
                              {showFullReason ? "Show Less" : "Read More"}
                            </button>
                          )}
                        </div>
                      )}
                    </>
                  ) : statusType === "SignUp" ? (
                    <>
                      <span
                        className={`inline-block rounded-full px-3 py-1 text-sm font-semibold ${
                          isselectedStatus
                            ? "bg-green-100 text-green-800 hover:bg-green-200"
                            : "bg-red-100 text-yellow-800 hover:bg-red-200"
                        }`}
                      >
                        {isselectedStatus ? selectedStatus : statusType}
                      </span>
                      {canManage && (
                        <MdEditSquare
                          onClick={() => setShowStatusPopup(true)}
                          className={`ml-2 inline-block cursor-pointer
                          ${
                            isselectedStatus
                              ? "text-green-700 hover:text-green-900"
                              : "text-red-700 hover:text-red-900"
                          }`}
                        />
                      )}
                    </>
                  ) : // <span className="inline-block rounded-full bg-red-100 px-3 py-1 text-sm font-semibold text-red-700">
                  //   {statusType}
                  // </span>
                  statusType === "register" ? (
                    <>
                      <span
                        className={`inline-block rounded-full px-3 py-1 text-sm font-semibold ${
                          isselectedStatus
                            ? "bg-green-100 text-green-800 hover:bg-green-200"
                            : "bg-yellow-100 text-yellow-800 hover:bg-yellow-200"
                        }`}
                      >
                        {isselectedStatus ? selectedStatus : statusType}
                      </span>
                      {canManage && (
                        <MdEditSquare
                          onClick={() => setShowStatusPopup(true)}
                          className={`ml-2 inline-block cursor-pointer
                          ${
                            isselectedStatus
                              ? "text-green-700 hover:text-green-900"
                              : "text-yellow-700 hover:text-yellow-900"
                          }`}
                        />
                      )}
                    </>
                  ) : statusType === "active" ? (
                    <>
                      <span
                        className={`inline-block rounded-full px-3 py-1 text-sm font-semibold    ${
                          isselectedStatus
                            ? "bg-yellow-100 text-yellow-800 hover:bg-yellow-200"
                            : "bg-green-100 text-green-800 hover:bg-green-200"
                        }`}
                      >
                        {isselectedStatus ? selectedStatus : statusType}
                      </span>
                      {canManage && (
                        <MdEditSquare
                          onClick={() => setShowStatusPopup(true)}
                          className={`ml-2 inline-block cursor-pointer
                          ${
                            isselectedStatus
                              ? "text-yellow-700 hover:text-yellow-900"
                              : "text-green-700 hover:text-green-900"
                          }`}
                        />
                      )}
                    </>
                  ) : null}
                </p>
              </div>
            )}
            {userData?.maritalStatus &&
              userData?.maritalStatus !== "never married" && (
                <p className="mb-2 w-full md:w-1/2">
                  <span className="font-medium">Children Count:</span>{" "}
                  {basicInfo?.childrenCount || "0"}
                </p>
              )}
          </div>
        </div>
        {/* Status Popup */}
        {showStatusPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="w-[300px] rounded-lg bg-white p-6 shadow-lg">
              <label className="mb-2 block text-gray-700">Active Status:</label>
              <select
                className="mb-4 w-[90%] rounded border px-3 py-2"
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                <option value="">-- Select Status --</option>
                <option value="active">Active</option>
                <option value="register">Registered</option>
                <option value="signup">SignUp</option>
                <option value="notInterest">Not Interested</option>
                <option value="noResponse">No Response</option>
              </select>
              {errors && (
                <p className="flex w-full text-start text-xs text-textRed">
                  Please select the active status
                </p>
              )}
              {(selectedStatus === "noResponse" ||
                selectedStatus === "notInterest") && (
                <>
                  <label className="mb-2 block">Reason :</label>
                  <textarea
                    placeholder="Enter reason..."
                    rows="3"
                    className="w-full rounded-md border border-gray-300 p-2 text-sm focus:border-blue-500"
                    value={statusReason}
                    onChange={handleReasonChange}
                  ></textarea>
                  {statusError && (
                    <p className="mt-2 text-left text-xs text-red-600">
                      {statusError}
                    </p>
                  )}
                </>
              )}
              <div className="flex justify-between">
                <button
                  onClick={() => handleClose()}
                  className="rounded bg-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-400"
                >
                  Close
                </button>
                <button
                  onClick={handleStatusChange}
                  className="rounded bg-blue-500 px-4 py-2 text-sm text-white hover:bg-blue-700"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Basic Information */}
        <div className="mb-2 bg-white px-4">
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:w-1/2">
              <h3 className="font-jost mb-2 text-xl text-textYellow ">
                Basic Information
              </h3>
              <p className="mb-2">
                <span className="font-medium">Current City:</span>{" "}
                {basicInfo.currentPlace || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">State:</span>{" "}
                {basicInfo.state || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Country:</span>{" "}
                {basicInfo.country || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Nationality:</span>{" "}
                {basicInfo.nationality || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">EthnicOrigin:</span>{" "}
                {basicInfo.ethnicOrigin || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Height:</span>{" "}
                {basicInfo?.height || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Weight:</span>{" "}
                {basicInfo?.weight || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Body Type:</span>{" "}
                {basicInfo?.bodyType || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Complexion:</span>{" "}
                {basicInfo?.complexion || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Mother Tongue:</span>{" "}
                {basicInfo?.motherTongue || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Languages Can Speak:</span>{" "}
                {basicInfo?.languagesCanSpeak?.join(", ") || "NA"}
              </p>
              {basicInfo?.activities && (
                <p className="mb-2">
                  <span className="font-medium">
                    Favorite Recreational Activities:
                  </span>{" "}
                  {basicInfo.activities}
                </p>
              )}
              <p className="mb-2">
                <span className="font-medium">Describe Yourself:</span>{" "}
                {basicInfo?.describeYourself || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Want Children:</span>{" "}
                {basicInfo?.wantChildren || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Medical History:</span>{" "}
                {basicInfo?.medicalHistory || "NA"}
              </p>
            </div>

            {/* Right - Spiritual Information */}
            <div className="w-full md:w-1/2">
              <h3 className="font-jost mb-2 text-xl text-textYellow ">
                Spiritual Information
              </h3>
              <p className="mb-2">
                <span className="font-medium">Initiated Name:</span>{" "}
                {basicInfo?.initiatedName || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">
                  No of rounds Hare Krishna Maha Mantra:
                </span>{" "}
                {userData?.countOfMantra || "0"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Spiritual Status:</span>{" "}
                {basicInfo?.spiritualStatus || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Spiritual Master:</span>{" "}
                {basicInfo?.spiritualMaster || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Connected Temple:</span>{" "}
                {basicInfo?.connectedTemple || "NA"}
              </p>
              <p className="mb-2">
                <span className="font-medium">Four Regulative Principles:</span>{" "}
                {basicInfo?.fourRegulativePrinciples?.join(", ") || "NA"}
              </p>
              {basicInfo?.devotionalService && (
                <p className="mb-2">
                  <span className="font-medium">
                    Favorite Devotional Service:
                  </span>{" "}
                  {basicInfo.devotionalService}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Contact Information */}
        {(role === "admin" ||
          role === "superAdmin" ||
          pathName[1] === "accepted-users" ||
          pathName[1] === "profile") && (
          <div className="mb-2 bg-white px-4">
            <h3 className="font-jost mb-2 text-xl text-textYellow">
              Contact Information
            </h3>
            <div className="flex flex-col md:flex-row md:flex-wrap">
              <p className="mb-2 w-full md:w-1/2">
                <span className="font-medium">Phone:</span>{" "}
                {userData?.phone || "NA"}
              </p>
              <p className="mb-2 w-full md:w-1/2">
                <span className="font-medium">Created By:</span>{" "}
                {userData?.createdBy || "NA"}
              </p>
              <p className="mb-2 w-full md:w-1/2">
                <span className="font-medium">Email:</span>{" "}
                {userData?.primaryEmail || "NA"}
              </p>

              <p className="mb-2 w-full md:w-1/2">
                <span className="font-medium">Contact Person:</span>{" "}
                {userData?.contactPersonName || "NA"}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileDetails;
